import { getField, updateField } from "vuex-map-fields";
import { getNewId } from "@/utils/id";
import BaseBoundaryCondition from "./baseBoundaryCondition";
import api from "../api/api";

export const namespaced = true;

let baseUrl = "/hydraulic_head_boundary_conditions/";
let paginationUrl = "/reference_point_hydraulic_head_boundary_conditions/";

const baseBoundaryCondition = new BaseBoundaryCondition(
  baseUrl,
  paginationUrl
);

const getDefaultState = () => {
  return {
    ...structuredClone(baseBoundaryCondition.state),
    writeLoading: false,
    lineCoords: null,
    status: "empty",
    importLineCoords: [],
    importedYears: [],
    templateFileName: "Hydraulic_head_boundary_conditions.xlsx",
  };
};

export const state = getDefaultState();

export const mutations = {
  ...baseBoundaryCondition.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  RESET_IMPORT_STATE(state) {
    state.importItems = [];
    state.importLineCoords = [];
    state.uploadLoading = false;
    state.importLoading = false;
    state.ignoredReferencePoint = [];
    state.importedYears = [];
  },
  SET_IMPORT_LINE_COORDS(state, items) {
    state.importLineCoords = [...items];
  },
  SET_REFERENCE_POINT(state, { objs, newId }) {
    objs.forEach((obj) => (obj.properties.reference_point = newId));
  },
  EDIT_REFERENCE_POINTS(state, { oldId, newId }) {
    let referencePoint = state.items.find(
      (referencePoint) => referencePoint.id === oldId
    );
    referencePoint.id = newId;
  },
  SET_LINE_COORDS(state, lineCoords) {
    state.lineCoords = lineCoords;
  },
  updateField,
};

export const actions = {
  ...baseBoundaryCondition.actions,
  async fetchSingleLine(context) {
    let url = `${baseUrl}line_coords/?search=${context.rootGetters["project/selectedProjectId"]}`;
    let response = await api.get(url);
    context.commit("SET_LINE_COORDS", response["data"]);
  },
  async addNewItem(context) {
    let referencePointId = getNewId(context.state.items, "id");
    let referencePoint = {
      id: referencePointId,
      reference_point: referencePointId,
      hydraulicheadboundarycondition_set: [],
    };
    let ids = [];
    let years = context.rootState.project.currentProject.year_set;
    if (context.state.years.length) {
      years = context.state.years;
    }
    years.forEach((year) => {
      let id = getNewId(context.getters.getItems, "id", ids);
      referencePoint["hydraulicheadboundarycondition_set"].push(
        context.getters.getEmptyItem(id, referencePointId, year.id)
      );
      ids.push(id);
    });
    context.commit("ADD_ITEM", referencePoint);
    context.commit("ADD_COUNT", 1);
  },
  async uploadFile(context, formData) {
    formData.append(
      "project_id",
      context.rootGetters["project/selectedProjectId"]
    );
    context.commit("TOGGLE_UPLOAD_LOADING");
    try {
      const response = await api.post(`${paginationUrl}bulk_upload/`, formData);
      context.commit("SET_IMPORT_LINE_COORDS", response.data["line_coords"]);
      context.commit("ADD_IMPORT_ITEMS", response.data["results"]);
      context.commit(
        "ADD_IGNORE_REFERENCE_POINT",
        response.data["ignored_reference_point"]
      );
      context.commit("SET_DELETE_WARNING", response.data["delete_warning"]);
      context.commit("SET_IMPORTED_YEARS", response["data"]["file_year"]);
      context.commit("TOGGLE_UPLOAD_LOADING");
    } catch (e) {
      console.log(e);
      context.commit("TOGGLE_UPLOAD_LOADING");
    }
  },
  setState(context) {
    context.commit("SET_LINE_COORDS", state.importLineCoords);
  },
  setReferencePoint(context, { oldId, newId }) {
    let objs = context.getters.getItems.filter(
      (item) => item.properties.reference_point === oldId
    );
    context.dispatch("setDirtyOnArray", objs);
    context.commit("SET_REFERENCE_POINT", { objs, newId });
    context.commit("EDIT_REFERENCE_POINTS", { oldId, newId });
    context.commit("EDIT_AVAILABLE_ITEMS_REFERENCE_POINT", { oldId, newId });
  },
};

export const getters = {
  getField,
  getEmptyItem: (state) => (id, referencePointId, yearId) => {
    //TODO maybe move this to the server also
    let emptyObj = {};
    emptyObj.id = id;
    emptyObj.geometry = {};
    emptyObj.geometry.coordinates = JSON.parse(JSON.stringify(state.lineCoords));
    emptyObj.geometry.type = "LineString";
    emptyObj.properties = {};
    emptyObj.properties.year = yearId;
    emptyObj.properties.reference_point = referencePointId;
    return emptyObj;
  },
  getItems: (state) => {
    let hydraulicHeadBoundaryConditions = [];
    state.items.forEach((referencePoint) =>
      hydraulicHeadBoundaryConditions.push(
        ...referencePoint.hydraulicheadboundarycondition_set
      )
    );
    return hydraulicHeadBoundaryConditions;
  },
  getExportFileName: (state, getters, rootState) => {
    let projectName = rootState["project"].currentProject?.name
    return projectName + "_HydraulicHead_export.xlsx";
  },
  getHydraulicHeadBoundaryConditionsIds: (state, getters) => {
    return getters.getItems.map(
      (hydraulicHeadBoundaryCondition) => hydraulicHeadBoundaryCondition.id
    );
  },
};
